

















































import Vue from "vue";

// Vuex
import { mapActions, mapState } from "vuex";
import { RootState } from "@/store";
import { GET_AVAILABLE_SOFTWARE_VERSIONS } from "@/store/modules/ApplicationModule/actions";

// Model
import { VersionObfuscator } from "@/model/data/updates/VersionObfuscator";
import { SoftwareFilter } from "@/model/data/updates/SoftwareFilter";
import { GetI18nStringFromUpdateType } from "@/model/data/enums/UpdateTypeEnum";

class ObfuscatedSoftwareFilter {
    enabled: boolean = false;
    label: string;
    name: string;
    versions: string[] = [];
    id: number;

    constructor(id: number, name: string, label: string, singleVersion: string) {
        this.id = id;
        this.name = name;
        this.label = label;
        this.versions.push(singleVersion);
    }
}

export default Vue.extend({
    data() {
        return {
            search: "",
            lastSelectedItemsLength: 0,
            openMenu: false,
            selectedItems: [],
        };
    },
    props: ["customAttrs"],
    computed: {
        ...mapState({
            availableSoftwareFilter: (state: RootState): SoftwareFilter[] => state.application.availableSoftwareVersions,
        }),
        filterUpdateType() {
            return this.customAttrs.filterUpdateType;
        },
        label() {
            return this.$t(GetI18nStringFromUpdateType(this.filterUpdateType));
        },
        availableItems() {
            if (this.availableSoftwareFilter != null && this.availableSoftwareFilter.length > 0) {
                if (this.availableSoftwareFilter.find((sw) => sw.updateType == this.filterUpdateType)) {
                    return this.availableSoftwareFilter.find((sw) => sw.updateType == this.filterUpdateType).versionsList;
                } else return [];
            } else return [];
        },
        ids() {
            let ids = new Map<string, number>();
            let id = 0;
            this.availableSoftwareFilter
                .find((sw) => sw.updateType == this.filterUpdateType)
                .versionsList.forEach((element) => {
                    ids.set(element.version, id++);
                });
            return ids;
        },
        obfuscatedAvailableItems() {
            let obfuscatedAvailableItems = new Array<ObfuscatedSoftwareFilter>();
            if (this.availableItems && this.availableItems.length > 0) {
                this.availableItems.forEach((item) => {
                    let key = VersionObfuscator.obfuscate(item.version.trim());

                    let find = obfuscatedAvailableItems.find((v) => v.label === key);
                    if (find) {
                        find.versions.push(item.version.trim());
                    } else {
                        obfuscatedAvailableItems.push(new ObfuscatedSoftwareFilter(this.ids.get(item.version), item.name, key, item.version.trim()));
                    }
                });
            }
            let sortedItems = [];
            obfuscatedAvailableItems.forEach((item) => {
                sortedItems.push({ item: item, selected: this.selectedItems.includes(item.id) ? 1 : 0 });
            });
            sortedItems.sort((a, b) => {
                return b.selected - a.selected;
            });
            return sortedItems.map((a) => a.item);
        },
    },
    methods: {
        ...mapActions([GET_AVAILABLE_SOFTWARE_VERSIONS]),
        GetI18nStringFromUpdateType,

        filter() {
            let ret = [];
            this.selectedItems.forEach((id) => {
                let v = this.obfuscatedAvailableItems.filter((o) => o.id == id);
                console.log(v);
                if (v && v.length == 1) ret.push(...v[0].versions.map((k) => ({ name: v[0].name, version: k })));
            });
            this.$emit("input", ret);
            this.lastSelectedItemsLength = ret.length;
            this.openMenu = false;
            this.search = "";
        },
    },
    async created() {
        if (!this.availableSoftwareFilter || !this.availableSoftwareFilter.length) await this[GET_AVAILABLE_SOFTWARE_VERSIONS]();
    },
});
